import React, { Component } from "react";
import { observer } from "mobx-react";
import "./LoginFlow.scss";
import LoginFlowState from "./LoginFlowState";

/**
 * @typedef {Object} LoginFlowProps
 * @property {LoginFlowState} store - The login flow state store
 */

@observer
class LoginFlow extends Component {
  render() {
    if (this.props.store.currentPage === "login") {
      return (
        <div className={"LoginFlow"}>
          <div className={"LoginFlow-header"}>login</div>
          <p>login to download tracks and save playlists</p>
          <div
            className={"Popup-banner-close"}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              this.props.store.close();
            }}
          />
          <div>
            <input
              type={"text"}
              placeholder={"email"}
              className={"LoginFlow-text-input"}
              value={this.props.store.loginEmail}
              onKeyDown={e => {
                // Disable keyboard shortcuts when we're typing in a text field
                e.stopPropagation();
              }}
              onChange={e => {
                this.props.store.setLoginEmail(e.target.value);
              }}
              autoFocus
            />
          </div>
          <div>
            <input
              type={"password"}
              placeholder={"password"}
              className={"LoginFlow-text-input"}
              value={this.props.store.loginPassword}
              onKeyDown={e => {
                if (e.key === "Enter") {
                  this.props.store.login();
                }
                // Disable keyboard shortcuts when we're typing in a text field
                e.stopPropagation();
              }}
              onChange={e => {
                this.props.store.setLoginPassword(e.target.value);
              }}
            />
          </div>
          <div>
            <button
              type={"button"}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.login();
              }}
            >
              login
            </button>
          </div>
          <div className={"LoginFlow-bad-login"}>
            {this.props.store.lastLoginFailed
              ? "incorrect username or password"
              : ""}
          </div>
          <div className={"LoginFlow-forgot-password-row"}>
            <a
              href={""}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.toForgotPassword();
              }}
            >
              forgot your password?
            </a>
          </div>
          <div className={"LoginFlow-sign-up-row"}>
            don&apos;t have an account?{" "}
            <a
              href={""}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.toCreateAccount();
              }}
            >
              sign up
            </a>
          </div>
        </div>
      );
    }
    if (this.props.store.currentPage === "forgot") {
      // Simple email validation regex
      const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      };

      let resetButton;
      const email = this.props.store.loginEmail;

      if (!email || !isValidEmail(email)) {
        resetButton = <span>Please enter a valid email address</span>;
      } else {
        resetButton = (
          <button
            type={"button"}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              this.props.store.resetPassword();
            }}
          >
            send reset email
          </button>
        );
      }

      return (
        <div className={"LoginFlow"}>
          <div className={"LoginFlow-header"}>reset password</div>
          <div>
            <input
              type={"text"}
              placeholder={"email"}
              className={"LoginFlow-text-input"}
              value={this.props.store.loginEmail}
              onKeyDown={e => {
                // Disable keyboard shortcuts when we're typing in a text field
                e.stopPropagation();
              }}
              onChange={e => {
                this.props.store.setLoginEmail(e.target.value);
              }}
            />
          </div>
          <div>
            {resetButton}
          </div>
          <div className={"LoginFlow-forgot-password-row"}>
            <a
              href={""}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.backToLogin();
              }}
            >
              back to login
            </a>
          </div>
        </div>
      );
    }
    if (this.props.store.currentPage === "forgot-success") {
      return (
        <div className={"LoginFlow"}>
          <div className={"LoginFlow-header"}>reset email sent!</div>
          <div className={"LoginFlow-created-message-row"}>
            If you have an account with us, we've sent you an email with a link to reset your password
          </div>
          <div>
            <button
              type={"button"}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.close();
              }}
            >
              close
            </button>
          </div>
        </div>
      );
    }
    if (this.props.store.currentPage === "create") {
      let signUpButton;

      if (this.props.store.createAccountPending) {
        signUpButton = <span>Creating account...</span>;
      } else if (
        this.props.store.createPassword.length > 0 &&
        this.props.store.createEmail.length > 0
      ) {
        if (this.props.store.createPassword.length < 7) {
          signUpButton = <span>Password must be at least 7 characters</span>;
        } else if (
          this.props.store.createPassword !==
          this.props.store.createRepeatPassword
        ) {
          signUpButton = <span>Passwords must match</span>;
        } else {
          signUpButton = (
            <button
              type={"button"}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.createAccount();
              }}
            >
              sign up
            </button>
          );
        }
      }

      return (
        <div className={"LoginFlow"}>
          <div className={"LoginFlow-header"}>sign up</div>
          <div>
            <input
              type={"text"}
              placeholder={"email"}
              className={"LoginFlow-text-input"}
              value={this.props.store.createEmail}
              onKeyDown={e => {
                // Disable keyboard shortcuts when we're typing in a text field
                e.stopPropagation();
              }}
              onChange={e => {
                this.props.store.setCreateEmail(e.target.value);
              }}
            />
          </div>
          <div>
            <input
              type={"password"}
              placeholder={"password - 7 characters minimum"}
              className={"LoginFlow-text-input"}
              value={this.props.store.createPassword}
              onKeyDown={e => {
                // Disable keyboard shortcuts when we're typing in a text field
                e.stopPropagation();
              }}
              onChange={e => {
                this.props.store.setCreatePassword(e.target.value);
              }}
            />
          </div>
          <div>
            <input
              type={"password"}
              placeholder={"repeat password"}
              className={"LoginFlow-text-input"}
              value={this.props.store.createRepeatPassword}
              onKeyDown={e => {
                // Disable keyboard shortcuts when we're typing in a text field
                e.stopPropagation();
              }}
              onChange={e => {
                this.props.store.setCreateRepeatPassword(e.target.value);
              }}
            />
          </div>
          <div>{signUpButton}</div>
          <div className={"LoginFlow-bad-login"}>
            {this.props.store.lastCreateFailed
              ? "that username already exists"
              : ""}
          </div>
          <div className={"LoginFlow-forgot-password-row"}>
            <a
              href={""}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.toForgotPassword();
              }}
            >
              forgot your password?
            </a>
          </div>
          <div className={"LoginFlow-forgot-password-row"}>
            {this.props.store.showingPrivacyPolicy ? (
              <span>
                we will not disclose any personal
                <br />
                information that we collect from you
              </span>
            ) : (
              <a
                href={""}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.props.store.showPrivacyPolicy();
                }}
              >
                privacy policy
              </a>
            )}
          </div>
          <div className={"LoginFlow-forgot-password-row"}>
            <a
              href={""}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.backToLogin();
              }}
            >
              back to login
            </a>
          </div>
        </div>
      );
    }
    if (this.props.store.currentPage === "create-success") {
      return (
        <div className={"LoginFlow"}>
          <div className={"LoginFlow-header"}>welcome</div>
          <div className={"LoginFlow-created-message-row"}>
            your account has been successfully created
          </div>
          <div>
            <button
              type={"button"}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.close();
              }}
            >
              close
            </button>
          </div>
        </div>
      );
    }
    if (this.props.store.currentPage === "change-password") {
      return (
        <div className={"LoginFlow"}>
          <div className={"LoginFlow-header"}>choose a new password</div>
          <div>
            <input
              type={"password"}
              placeholder={"password - 7 characters minimum"}
              className={"LoginFlow-text-input"}
              value={this.props.store.createPassword}
              onKeyDown={e => {
                // Disable keyboard shortcuts when we're typing in a text field
                e.stopPropagation();
              }}
              onChange={e => {
                this.props.store.setCreatePassword(e.target.value);
              }}
            />
          </div>
          <div>
            <input
              type={"password"}
              placeholder={"repeat password"}
              className={"LoginFlow-text-input"}
              value={this.props.store.createRepeatPassword}
              onKeyDown={e => {
                // Disable keyboard shortcuts when we're typing in a text field
                e.stopPropagation();
              }}
              onChange={e => {
                this.props.store.setCreateRepeatPassword(e.target.value);
              }}
            />
          </div>
          <div>
            <button
              type={"button"}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.changePassword();
              }}
            >
              change password
            </button>
          </div>
        </div>
      );
    }
    if (this.props.store.currentPage === "change-success") {
      return (
        <div className={"LoginFlow"}>
          <div className={"LoginFlow-header"}>welcome back</div>
          <div className={"LoginFlow-created-message-row"}>
            your password has been successfully changed
          </div>
          <div>
            <button
              type={"button"}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                this.props.store.close();
              }}
            >
              close
            </button>
          </div>
        </div>
      );
    }
    // This should never happen, it means we're on an unsupported page
    return null;
  }
}

export default LoginFlow;
